<template>
  <!-- prettier-ignore -->
  <ovp-text-input
    v-model="internalValue"
    inputmode="decimal"
    manual-validation
    v-bind="$attrs"
    :delay="delay"
    :hint="autoHint"
    :mask="isNative ? false : '##.##.####'"
    :max="max"
    :min="min"
    :name="name"
    :placeholder="placeholder"
    :readonly="readonly"
    :theme="theme"
    :title="title"
    :type="isNative ? 'date' : 'text'"
    :value="internalValue"
    :validate="validate"
    @blur="update">
    <slot />
  </ovp-text-input>
</template>

<script>
import { debounce } from 'lodash'
import { DateTimeHelper } from '@/helpers/DateTime'
import { DATE_FORMAT_DIN, DATE_FORMAT_ISO } from '@/config/constants'

export default {
  name: 'OvpDateInput',

  model: {
    prop: 'value',
    event: 'update',
  },

  props: {
    delay: {
      type: Number,
      default: 0,
    },

    hint: {
      type: [String],
      default: '',
    },

    isActive: {
      type: Boolean,
      default: false,
    },

    isNative: {
      type: Boolean,
      default: false,
    },

    min: {
      type: String,
      default: null,
    },

    max: {
      type: String,
      default: null,
    },

    name: {
      type: String,
      required: true,
    },

    noHint: {
      type: Boolean,
      default: false,
    },

    placeholder: {
      type: String,
      default: '',
    },

    readonly: {
      type: Boolean,
      default: false,
    },

    required: {
      type: Boolean,
      default: false,
    },

    theme: {
      type: String,
      default: 'light',
    },

    title: {
      type: String,
      required: true,
    },

    validate: {
      type: Object,
      default: () => {},
    },

    value: {
      type: [String, Number],
    },
  },

  data() {
    return {
      internalValue: null,
      updater: null,
    }
  },

  mounted() {
    this.dUpdate = debounce(this.update, 2500)
  },

  watch: {
    value: {
      immediate: true,
      handler: function (value) {
        const format = this.isNative ? DATE_FORMAT_ISO : DATE_FORMAT_DIN
        this.internalValue = DateTimeHelper.isValidDate(value) ? DateTimeHelper.formatDate(value, format) : value
      },
    },

    internalValue(value) {
      if (DateTimeHelper.isValidDate(value)) {
        if (this.updater) this.updater.cancel()
        this.update()
      } else {
        this.updater = this.dUpdate(value)
      }
    },
  },

  computed: {
    date() {
      if (DateTimeHelper.isValidDate(this.value)) {
        return DateTimeHelper.formatDate(this.value)
      } else {
        return this.value
      }
    },

    autoHint() {
      return this.noHint ? '' : this.hint || this.$t('form.dateHint')
    },
  },

  methods: {
    update() {
      let value = this.internalValue

      this.validate?.$touch()

      if (DateTimeHelper.isValidDate(value)) {
        value = DateTimeHelper.formatDate(value, DATE_FORMAT_ISO)
      }

      this.$emit('update', value)
    },
  },
}
</script>
